<template>
    <div class="comment__reply">
        <div class="reply__image">

            <img v-if="data.author.image" :src="'https://api.library.loxone.com'+data.author.image" />
        </div>
        <div class="reply__text">
            <div class="text" v-html="filterString(data.text)"></div>
            <div class="meta">
                <span class="creator">{{data.author.displayname}}</span> - {{formatDate(data.date)}}
            </div>
            <div v-if="$store.state.loggedIn && $store.state.userData.user_id == data.author.id" class="controls">
                <span @click="deleteReply()">{{ $t('action.delete')}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default{
        props: {
            data: {
                type: Object,
                required: false,
            },
            type: {
                type: String,
                required: false,
            }
        },
        data() {
            return {
                reply: '',
            }
        },
        methods: {
            filterString(string = false) {
                if(string) {
                    string = string.replaceAll('\\n\\r', '<br>');
                    string = string.replaceAll('\\n', '<br>');
                    string = string.replaceAll('\\r', '<br>');
                    string = string.replaceAll('\\', '');
                    return string;
                }
                return "";
            },
            formatDate(date) {
                const time_difference = (Math.floor((new Date() - new Date(date)) / (1000*60*60*24)));
                if(time_difference > 365) {
                    if(Math.floor(time_difference / 365) == 1) {
                        return Math.floor(time_difference / 365) + ' year ago';
                    } else {
                        return Math.floor(time_difference / 365) + ' years ago';
                    }
                } else if(time_difference > 30) {
                    if(Math.floor(time_difference / 30) == 1) {
                        return Math.floor(time_difference / 30) + ' month ago';
                    } else {
                        return Math.floor(time_difference / 30) + ' months ago';
                    }
                }
                switch(time_difference){
                    case 0:
                        return 'today';
                    case 1:
                        return 'yesterday';
                    default:
                        return time_difference + ' days ago';
                }
            },
            deleteReply() {
                var commentMeta = new FormData();
                commentMeta.append('reply_id', this.data.id);
                commentMeta.append('user_id', this.$store.state.userData.user_id);

                let actionUrl = 'https://api.library.loxone.com/deleteCommentReply';
                if(this.type == 'issue') {
                    actionUrl = 'https://api.library.loxone.com/deleteIssueReply';
                }

                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: actionUrl,
                    data: commentMeta,
                }).then(() => (location.reload()));
            }
        },
    }
</script>